/* eslint-disable react/destructuring-assignment */
import React, { useState, useContext } from "react";
import { array, bool, func } from "prop-types";
import { transactionStatus } from "pages/transactions/constants";
import GridTable from "pages/_components/GridTable/GridTable";
import Button from "pages/_components/Button";
import { TransactionSign } from "pages/_components/TransactionCard";
import * as i18n from "util/i18n";
import EcheqHeaderTicket from "pages/echeck/components/EcheqHeaderTicket";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { EcheqActions } from "pages/echeck/constants";
import CustomData from "../../../_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import { Spring, config } from "react-spring";
import InfoTag from "pages/echeck/components/InfoTag";
import FormattedAmount from "pages/_components/FormattedAmount";

const TransactionSummaryBody = (props) => {
    const { transaction } = useContext(TransactionContext);
    const { showMoreData, setShowMoreData, isDesktop, accounts } = props;
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const { data: echeckAction = {}, idTransaction = "", idTransactionStatus } = transaction;
    const isPending = idTransactionStatus === transactionStatus.PENDING;

    const {
        address = props.address,
        reference = props.reference,
        referencevalue = props.referencevalue,
        echeqList = props.echeqList,
        cesion = {},
        accountDescription: creditAccountDescription,
    } = echeckAction;

    const getLabelMotive = (action) => {
        switch (action) {
            case EcheqActions.ANULATE:
            case EcheqActions.ANULATE_ENDORSE:
            case EcheqActions.ANULATE_CESION:
                return "echeck.anulate.label";
            case EcheqActions.REPUDIATE:
            case EcheqActions.REPUDIATE_CESION:
                return "echeck.repudiate.label";
            default:
                return "echecks.emit.motive.label";
        }
    };

    const getMotive = (action) => {
        switch (action) {
            case EcheqActions.ANULATE:
            case EcheqActions.ANULATE_ENDORSE:
            case EcheqActions.ANULATE_CESION:
            case EcheqActions.REPUDIATE:
            case EcheqActions.REPUDIATE_CESION:
                return echeckAction.specialAttribute || "";
            default:
                return echeq.cheque_motivo_pago || "";
        }
    };

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };

    const statusName = () => {
        let state;
        if (idTransactionStatus == "FAILED") state = "error";
        if (idTransactionStatus == "PENDING") state = "pending";
        if (idTransactionStatus == "CANCELLED") state = "cancelled";

        return `echeqs.cesion.status.${state || "success"}`;
    };

    const statusTagColor = () => {
        if (idTransactionStatus == "FAILED") return "error";
        if (idTransactionStatus == "PENDING") return "warning";
        if (idTransactionStatus == "CANCELLED") return "error";
        if (idTransactionStatus == "FINISHED") return "success";
    };

    const echeqTotal = () => {
        return echeqList.reduce((acum, item) => acum + item?.monto, 0);
    };

    const echeq = echeqList[0];

    return (
        <div className="ticket__body echeq-endorse">
            <>
                <EcheqHeaderTicket
                    estado={echeq.finalStatus || echeq.estado}
                    caracter={echeq.cheque_caracter}
                    moneda={echeq.moneda}
                    monto={echeqTotal()}
                    id={echeq.cheque_numero}
                    status={idTransactionStatus}
                    isDesktop={isDesktop}
                />
                <div className="view-more-data-button">
                    <div className="ticket__divider inside-ticket__body">
                        <div className="ticket__notch ticket__notch--left"> </div>
                        <div className="ticket__notch ticket__notch--right"> </div>
                    </div>
                    <Button
                        aria-expanded={showMoreData ? "true" : "false"}
                        className="more-button"
                        label={buttonLabel}
                        bsStyle="link"
                        onClick={handleSeeMoreData}
                        image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                    />
                </div>
                <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                    <div className={isDesktop ? "ticket-section" : ""}>
                        <div
                            style={{
                                display: "block",
                                width: "100%",
                                gridColumn: "1 / -1",
                            }}>
                            <GridTable>
                                <GridTable.Container className="ticket-gap">
                                    <GridTable.Data columnStart={1} rowStart={1}>
                                        <h2>{i18n.get("echecks.emissor", "Emisor")}</h2>
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={1} rowStart={2} alignY="flex-start">
                                        <CustomData
                                            titleText="echeqs.emit.reference.socialdenomination"
                                            titleTextType="I18N"
                                            valueText={echeq.emisor_razon_social}
                                        />
                                    </GridTable.Data>

                                    <GridTable.Data columnStart={1} rowStart={3}>
                                        <CustomData
                                            titleText="echecks.document"
                                            titleTextType="I18N"
                                            valueText={`CUIT ${echeq.emisor_cuit}`}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={1} rowStart={4}>
                                        <CustomData
                                            titleText="echecks.createdRange.label"
                                            titleTextType="I18N"
                                            valueText={echeq.fecha_emision}
                                            valueTextType="DATE"
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={1} rowStart={5}>
                                        <CustomData
                                            titleText="echecks.emit.emision.label"
                                            titleTextType="I18N"
                                            valueText={`····${echeq?.emisor_cbu?.slice(-4)} ${
                                                echeq?.cheque_tipo
                                            } ${i18n.get(`currency.label.${echeq?.emisor_moneda}`)}`}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} rowStart={1}>
                                        <h2>{i18n.get("echecks.beneficiary")}</h2>
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} rowStart={2}>
                                        <CustomData
                                            titleText="echeqs.emit.reference.socialdenomination"
                                            titleTextType="I18N"
                                            valueText={echeq.beneficiario_nombre}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} rowStart={3}>
                                        <CustomData
                                            titleText="echecks.document"
                                            titleTextType="I18N"
                                            valueText={`${echeq.beneficiario_documento_tipo} ${echeq.beneficiario_documento}`}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} rowStart={4}>
                                        <CustomData
                                            titleText="echecks.payedRange.label"
                                            titleTextType="I18N"
                                            valueText={echeq.fecha_pago}
                                            valueTextType="DATE"
                                        />
                                    </GridTable.Data>
                                    {echeckAction.action === EcheqActions.DEPOSIT && (
                                        <GridTable.Data columnStart={2} rowStart={5}>
                                            <CustomData
                                                titleText="echeck.deposit.label"
                                                titleTextType="I18N"
                                                valueText={creditAccountDescription}
                                                valueTextType="TEXT"
                                            />
                                        </GridTable.Data>
                                    )}
                                    {echeckAction.action === EcheqActions.CUSTODY && (
                                        <GridTable.Data columnStart={2} rowStart={5}>
                                            <CustomData
                                                titleText="echeck.custody.label"
                                                titleTextType="I18N"
                                                valueText={creditAccountDescription}
                                                valueTextType="TEXT"
                                            />
                                        </GridTable.Data>
                                    )}
                                </GridTable.Container>
                            </GridTable>
                        </div>{" "}
                        <div className="ticket__divider divider_2 inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <div className="aditional-data">
                            <h2>{i18n.get("", "Datos adicionales")}</h2>
                            <CustomData
                                titleText="echecks.echeckConcept"
                                titleTextType="I18N"
                                valueText={echeq.cheque_concepto}
                                valueTextType="TEXT"
                            />

                            <CustomData
                                titleText={getLabelMotive(echeckAction.action)}
                                titleTextType="I18N"
                                valueText={getMotive(echeckAction.action)}
                                valueTextType="TEXT"
                            />
                            <CustomData
                                titleText="echecks.echeckReference"
                                titleTextType="I18N"
                                valueText={echeq?.referencia || "N/A"}
                                valueTextType="TEXT"
                            />
                            <CustomData
                                titleText="echecks.cmc7"
                                titleTextType="I18N"
                                valueText={echeq.cmc7}
                                valueTextType="TEXT"
                            />
                            <CustomData
                                titleText="echecks.echeckType"
                                titleTextType="I18N"
                                valueText={echeq.cheque_tipo}
                                valueTextType="TEXT"
                            />
                            <GridTable.Data>
                                <CustomData
                                    titleText="echecks.currency"
                                    titleTextType="I18N"
                                    valueText={echeq?.moneda}
                                />
                            </GridTable.Data>
                            {(echeckAction.action === EcheqActions.ADMIT_CESION ||
                                echeckAction.action === EcheqActions.ANULATE_CESION ||
                                echeckAction.action === EcheqActions.REPUDIATE_CESION ||
                                echeckAction.action === EcheqActions.ADMIT ||
                                echeckAction.action === EcheqActions.REPUDIATE ||
                                echeckAction.action === EcheqActions.CUSTODY ||
                                echeckAction.action === EcheqActions.DEPOSIT) && (
                                <>
                                    <GridTable.Data>
                                        <CustomData
                                            titleText="echeq.request.amount.label"
                                            titleTextType="I18N"
                                            valueText={echeqList?.length}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data>
                                        <CustomData
                                            titleText="echeq.transaction.check.amount.label"
                                            titleTextType="I18N"
                                            valueText={echeqTotal()}
                                            valueTextType={echeq.emisor_moneda}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data>
                                        <CustomData
                                            titleText="echecks.echeckReferenceValue"
                                            titleTextType="I18N"
                                            valueText={echeq?.referencia_valor || "N/A"}
                                            valueTextType="TEXT"
                                        />
                                    </GridTable.Data>
                                </>
                            )}
                            {echeqList?.length > 1 && (
                                <>
                                    <div className="ticket__divider divider_2 inside-ticket__body">
                                        <div className="ticket__notch ticket__notch--left"> </div>
                                        <div className="ticket__notch ticket__notch--right"> </div>
                                    </div>
                                    <div
                                        style={{
                                            display: "block",
                                            width: "100%",
                                            gridColumn: "1 / -1",
                                        }}>
                                        <GridTable>
                                            {isDesktop && (
                                                <GridTable.Container className="three-cols" columns={3} rows={1}>
                                                    <GridTable.Data columnWidth={1} columnStart={1} rowStart={1}>
                                                        <CustomText className="title-discounts" text={""} />
                                                    </GridTable.Data>
                                                    <GridTable.Data columnWidth={1} columnStart={2} rowStart={1}>
                                                        <CustomText
                                                            className="title-discounts font-bold"
                                                            text={i18n.get("echecks.status")}
                                                        />
                                                    </GridTable.Data>
                                                    <GridTable.Data
                                                        columnWidth={1}
                                                        columnStart={3}
                                                        rowStart={1}
                                                        alignX="center">
                                                        <CustomText
                                                            className="title-discounts font-bold"
                                                            text={i18n.get("echeq.transaction.amount.label")}
                                                        />
                                                    </GridTable.Data>
                                                </GridTable.Container>
                                            )}
                                            <Spring
                                                config={config.stiff}
                                                from={{ height: 0 }}
                                                to={{
                                                    height: echeqList.length ? "auto" : 0,
                                                    overflow: "hidden",
                                                }}>
                                                {(styles) => (
                                                    <div className="form-group" style={styles}>
                                                        <div className="form-group-control-list">
                                                            {echeqList.map((echeq, index) => (
                                                                <GridTable.Container
                                                                    className="three-cols"
                                                                    columns={3}
                                                                    rows={1}
                                                                    key={index}>
                                                                    <GridTable.Data
                                                                        columnWidth={1}
                                                                        columnStart={1}
                                                                        rowStart={1}>
                                                                        {isDesktop ? (
                                                                            <CustomText
                                                                                text={`Echeq ${echeq.cheque_numero}`}
                                                                            />
                                                                        ) : (
                                                                            <CustomData
                                                                                titleText="detail.discounts.echek.id"
                                                                                titleTextType="I18N"
                                                                                valueText={`Echeq ${echeq.cheque_numero}`}
                                                                            />
                                                                        )}
                                                                    </GridTable.Data>
                                                                    <GridTable.Data
                                                                        columnWidth={1}
                                                                        columnStart={2}
                                                                        rowStart={1}>
                                                                        {isDesktop ? (
                                                                            <InfoTag
                                                                                type="info"
                                                                                message={i18n.get(statusName())}
                                                                                tagBackground={statusTagColor()}
                                                                            />
                                                                        ) : (
                                                                            <CustomData
                                                                                titleText="payments.table.status"
                                                                                titleTextType="I18N"
                                                                                valueText={
                                                                                    <InfoTag
                                                                                        type="info"
                                                                                        message={i18n.get(statusName())}
                                                                                        tagBackground={statusTagColor()}
                                                                                    />
                                                                                }
                                                                            />
                                                                        )}
                                                                    </GridTable.Data>
                                                                    <GridTable.Data
                                                                        columnWidth={1}
                                                                        columnStart={3}
                                                                        rowStart={1}
                                                                        alignX="center">
                                                                        {isDesktop ? (
                                                                            <CustomText
                                                                                text={
                                                                                    <FormattedAmount
                                                                                        currency={echeq.moneda}
                                                                                        quantity={echeq.monto}
                                                                                    />
                                                                                }
                                                                                textType="TEXT"
                                                                            />
                                                                        ) : (
                                                                            <CustomData
                                                                                titleText="echeq.transaction.amount.label"
                                                                                titleTextType="I18N"
                                                                                valueText={
                                                                                    <FormattedAmount
                                                                                        currency={echeq.moneda}
                                                                                        quantity={echeq.monto}
                                                                                    />
                                                                                }
                                                                                textType="TEXT"
                                                                            />
                                                                        )}
                                                                    </GridTable.Data>
                                                                    {index !== echeqList.length - 1 && !isDesktop && (
                                                                        <div className="ticket__divider inside-ticket__body">
                                                                            <div className="ticket__notch ticket__notch--left" />
                                                                            <div className="ticket__notch ticket__notch--right" />
                                                                        </div>
                                                                    )}
                                                                </GridTable.Container>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </Spring>
                                        </GridTable>
                                    </div>
                                </>
                            )}
                        </div>
                        <TransactionSign
                            isSmall
                            creationTime
                            hasVaucher
                            isDesktop={isDesktop}
                            noDate={isPending}
                            showMoreData={showMoreData}
                        />
                    </div>
                </div>
            </>
        </div>
    );
};

TransactionSummaryBody.propTypes = {
    isDesktop: bool,
    showMoreData: bool,
    setShowMoreData: func,
    accounts: array,
};

TransactionSummaryBody.defaultProps = {
    isDesktop: false,
    showMoreData: false,
    setShowMoreData: () => {},
    accounts: [],
};

export default TransactionSummaryBody;
